module.exports = __webpack_public_path__ + "media/bootstrap-icons/volume-down-fill-69bce784.svg";